import {MenuItem} from '_metronic/layout/components/header/header-menus/MenuItem'
import {Modal} from 'app/custom/modal/Modal'
import {useCallback, useState} from 'react'
import {useTranslation} from 'react-i18next'
import MyCard from './profile/MyCard'

const StdMenu = () => {
  const {t} = useTranslation()
  const [isShown, setIsShown] = useState(false)
  const [showMore, setShowMore] = useState(false)

  const toggle = useCallback(() => setIsShown((prev) => !prev), [])

  const menus = [
    {
      title: t('LABEL.MY_PROFILE'),
      to: '/student/my-profile',
      icon: 'fas fa-user',
      bg: '#eef2ff',
      color: '#6366f1',
    },
    {
      title: t('LABEL.MY_COURSES'),
      to: '/student/my-courses',
      icon: 'fas fa-book-open',
      bg: '#ecfdf5',
      color: '#10b981',
    },
    {
      title: t('LABEL.MY_TRANSCRIPT'),
      to: '/student/my-transcript',
      icon: 'fas fa-scroll',
      bg: '#fef3c7',
      color: '#f59e0b',
    },
    {
      title: t('LABEL.MY_INVOICES'),
      to: '/student/my-invoices',
      icon: 'fas fa-file-invoice-dollar',
      bg: '#fee2e2',
      color: '#ef4444',
    },
    {
      title: t('MEETING.MEETINGS'),
      to: '/student/meetings',
      icon: 'fas fa-calendar-check',
      bg: '#ede9fe',
      color: '#8b5cf6',
    },
    {
      title: t('LABEL.MY_LETTERS'),
      to: '/student/my-letters',
      icon: 'fas fa-envelope-open-text',
      bg: '#fdf2f8',
      color: '#ec4899',
    },
    {
      title: t('LABEL.MY_RESOURCE'),
      to: '/student/my-resource',
      icon: 'fas fa-layer-group',
      bg: '#ecfeff',
      color: '#06b6d4',
    },
    {
      title: t('LABEL.MY_FEEDBACK'),
      to: '/student/my-feedback',
      icon: 'fas fa-comment-dots',
      bg: '#f0fdfa',
      color: '#14b8a6',
    },
    {
      title: t('LABEL.CHAT'),
      to: '/student/chat-room',
      icon: 'fas fa-comments',
      bg: '#f0fdf4',
      color: '#22c55e',
    },
  ]

  const moreMenus = [
    {
      title: t('LABEL.MY_CARD'),
      icon: 'fas fa-id-card',
      color: '#ef4444',
      action: toggle,
    },
    {
      title: t('LABEL.MY_DOCUMENTS'),
      to: '/student/my-documents',
      icon: 'fas fa-folder-open',
      color: '#3f8f8f',
      internal: true,
    },
    {
      title: t('LABEL.MY_NOTES'),
      to: '/student/my-notes',
      icon: 'fas fa-sticky-note',
      color: '#7d8f3d',
      internal: true,
    },
    {
      title: t('LABEL.MY_UMEF'),
      to: '/student/my-umef',
      icon: 'fas fa-university',
      color: '#7c3aed',
      internal: true,
    },
    {
      title: t('PARENT.PARENT_ACCOUNT'),
      to: '/student/parent',
      icon: 'fas fa-users',
      color: '#3f00ac',
      internal: true,
    },
  ]

  const renderCard = (icon: string, title: string, bg: string, color: string) => (
    <div
      className='menu-card d-flex flex-column align-items-center justify-content-center'
      style={{background: bg}}
    >
      <div className='icon-box mb-1'>
        <i className={icon} style={{color}}></i>
      </div>
      <span className='menu-text'>{title}</span>
    </div>
  )

  return (
    <div className='container-fluid d-flex flex-column align-items-center'>
      {/* MAIN ROW */}
      <div className='d-flex justify-content-center align-items-center gap-2 flex-nowrap'>
        {menus.map((menu, index) => (
          <div key={index}>
            <MenuItem to={menu.to} title={renderCard(menu.icon, menu.title, menu.bg, menu.color)} />
          </div>
        ))}

        {/* MORE BUTTON */}
        <div onClick={() => setShowMore(!showMore)}>
          {renderCard(
            'fas fa-ellipsis-h',
            t('LABEL.MORE'),
            'linear-gradient(135deg, #0dcaf0, #0aa2c0)',
            '#ffffff'
          )}
        </div>
      </div>

      {/* MORE PANEL */}
      {showMore && (
        <div className='more-container'>
          <div className='more-panel'>
            {moreMenus.map((menu, index) =>
              menu.action ? (
                <div key={index} onClick={menu.action} className='more-card text-center'>
                  <i className={menu.icon} style={{color: menu.color}}></i>
                  <div className='more-text'>{menu.title}</div>
                </div>
              ) : (
                <MenuItem
                  key={index}
                  to={menu.to}
                  title={
                    <div className='more-card text-center'>
                      <i className={menu.icon} style={{color: menu.color}}></i>
                      <div className='more-text'>{menu.title}</div>
                    </div>
                  }
                />
              )
            )}
          </div>
        </div>
      )}

      {/* MODAL */}
      <Modal
        isShown={isShown}
        hide={toggle}
        modalContent={<MyCard />}
        headerText={t('LABEL.MY_CARD')}
      />

      {/* STYLES */}
      <style>{`
      .menu-card {
        width: 95px;
        height: 90px;
        border-radius: 16px;
        transition: 0.25s;
        cursor: pointer;
        padding: 6px 4px;
      }

      .menu-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 10px 25px rgba(0,0,0,0.12);
      }

      .icon-box {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        background: rgba(255,255,255,0.7);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .icon-box i {
        font-size: 17px;
      }

      .menu-text {
        font-size: 12.5px;
        font-weight: 600;
        text-align: center;
        line-height: 14px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .more-container {
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 18px;
      }

      .more-panel {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        gap: 14px;
        padding: 18px;
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff, #eef2ff);
        box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        width: 100%;
      }

      .more-card {
        width: 140px;
        padding: 14px;
        border-radius: 16px;
        background: white;
        text-decoration: none;
        color: #333;
        transition: 0.25s;
      }

      .more-card:hover {
        transform: translateY(-4px) scale(1.05);
        background: #eef2ff;
      }

      .more-card i {
        font-size: 20px;
        margin-bottom: 6px;
      }

      .more-text {
        font-size: 13px;
        font-weight: 600;
      }
      `}</style>
    </div>
  )
}

export default StdMenu
